<template>
  <div class="home">
    <div class="flex-row">
      <div v-for="navbar in navbars" :key="navbar.id">
        <div class="flex-col">
          <router-link :to="navbar.router">{{ navbar.names }}</router-link>
        </div>
      </div>
    </div>

    <h3>Installed CLI Plugins</h3>
    <ul>
      <li>
        <a
          href="https://github.com/vuejs/vue-cli/tree/dev/packages/%40vue/cli-plugin-router"
          target="_blank"
          rel="noopener"
          >router</a
        >
      </li>
      <li>
        <a
          href="https://github.com/vuejs/vue-cli/tree/dev/packages/%40vue/cli-plugin-eslint"
          target="_blank"
          rel="noopener"
          >eslint</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "Home",
  data: function() {
    return {
      navbars: [
        { names: "Students", router: "/students" },
        { names: "Calculator", router: "/calculator" },
        { names: "Bitcoin (Api)", router: "/bitcoin" },
        { names: "To Do", router: "/todolist" },
        { names: "To Do (Api)", router: "/todolistapi" },
        { names: "E-Commerce", router: "/ecommerce" },
        { names: "Currency Convertor (Api)", router: "/currency" },
        { names: "Endgame", router: "/battle" }
      ]
    };
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Vollkorn:wght@600&display=swap");

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

a:hover {
  text-decoration: none;
}

.flex-row {
  display: flex;
  flex: 1;
  flex-direction: row;
  flex-wrap: wrap;
  font-family: "Vollkorn";
}

.flex-col:hover {
  background-color: yellow;
  /* transition: ease 0.1s all; */
  text-decoration: none;
}

/*desktop become 4 columns*/
.flex-col {
  margin: 6px;
  padding: 36px;
  border: 5px dotted silver;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  flex-direction: column;
  color: dimgrey;
  text-align: center;
  box-sizing: border-box;
  /* transition: ease 3s all; */
}

a.fill-div {
  display: block;
  height: 100%;
  width: 100%;
  text-decoration: none;
}

@media only screen and (min-width: 768px) {
  .flex-row {
    font-size: 300%;
  }
}

/*phone and tablet become 2 columns*/
@media (max-width: 767px) {
  .flex-col {
    flex-basis: calc(50% - 12px);
    font-size: 150%;
  }
}

/*@media (max-width:460px) {
  .flex-col {
    flex-basis: 100%;
  }
}*/
</style>
